<template>
    <div class="agency-rating-wrapper">
        <v-rating class="agency-rating" size="36" hover :disabled="loading" v-model="agencyRatingModel"
            :color="getRatingColor" @click="saveLogData" half-increments>
        </v-rating>
    </div>
    <div v-if="logData" class="change-log-wrapper">
        <v-data-table :headers="headers" :items-per-page="mobile ? 5 : 10" class="data-table-agency-logs" :items="logData.changes" rounded="lg" :sort-by="[{ key: 'date', order: 'desc' }]">
        </v-data-table>
    </div>
    <div class="text-area-wrapper">
        <v-textarea v-model="agencyTextareaModel" hide-details="true" placeholder="Notes" rows="10" variant="outlined"
            density="compact" no-resize :disabled="loading" :loading="loading" rounded="lg" class="text-area"></v-textarea>
        <v-btn rounded="lg" style="margin-top: 12px;" block class="text-area-btn gradient-color-primary" :disabled="loading" @click="saveLogData">Speichern</v-btn>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';
import {useDisplay} from 'vuetify'

export default {
    props: {
        agency: {
            type: Object,
            required: true
        },
        logData: {
            type: Object,
            required: true
        }
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    data() {
        return {
            agencyRatingModel: this.logData.rating || 0,
            agencyTextareaModel: this.logData.description || '',
            loadingLogData: false,
            headers : [
                { key: 'date', title: 'Datum'},
                { key: 'description', title: 'Änderung'},
                { key: 'user', title: 'Von'}
            ]
        };
    },
    created() {
        this.initializeData();
    },
    watch: {
        logData(newVal) {
            this.agencyRatingModel = newVal.rating || 0;
            this.agencyTextareaModel = newVal.description || '';
        }
    },
    computed: {
        ...mapState('agency', ['loading']),
        getRatingColor() {
            if (this.agencyRatingModel === 0) {
                return 'grey';
            } else if (this.agencyRatingModel <= 2) {
                return 'red';
            } else if (this.agencyRatingModel <= 3) {
                return 'orange';
            } else {
                return 'green';
            }
        },

    },
    methods: {
        ...mapActions('agency', ['saveLog']),
        ...mapMutations('agency', ['setLogData', 'setLoading']),
        initializeData() {
            // Initialize data properties from logData if available
            this.agencyRatingModel = this.logData.rating || 0;
            this.agencyTextareaModel = this.logData.description || '';
        },
        async saveLogData() {
            await this.$store.dispatch('agency/saveLog', {
                agencyId: this.agency._id,
                changes: this.changes,
                description: this.agencyTextareaModel,
                rating: this.agencyRatingModel
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.agency-rating-wrapper {
    display: flex;
    border-radius: 12px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
    background-color: #f9fafb;
}

.agency-rating {
    margin: 0 auto;
}

.text-area-wrapper {
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
    background-color: #f9fafb;

    @media screen and (max-width: 600px) {
        padding: 8px;
    }
}

.data-table-agency-logs {
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
}
</style>